import { connect } from 'react-redux';
import * as RX from 'reactxp';
import { Window } from '../../../reducers/window';
import { md } from '../../../utils/breakpoints';
import { mapStateToProps } from '../../../utils/mapper';
import { colors } from '../../../utils/styles';
import MenuSection from './menu_section';

interface MenuProps {
  catcherPress: () => void;
  menuSections: any;
  window: Window & { multiplier: number };
  dispatch: any;
};

const styles = {
  mainMenu: RX.Styles.createViewStyle({
    backgroundColor: 'rgba(204, 204, 204, 0.6)',
  }),
};

export class MenuContainer extends RX.Component<MenuProps, RX.CommonProps> {

  constructor(props: MenuProps) {
    super(props);
  }

  public componentWillUnmount() {
    this.props.dispatch({ type: 'MENU_SIZE', height: 0 });
  }

  public render() {
    const { catcherPress, menuSections, window: { height, width, multiplier, menuHeight = 0, landscape } } = this.props;
    const ios = RX.Platform.getType() === 'ios';
    return (
      <RX.View style={[
        styles.mainMenu,
        { width },
        width >= md
        ? {
          backgroundColor: colors.white,
          flexDirection: 'row',
          justifyContent: 'center',
          minHeight: ios && !landscape ? 90 * multiplier : 40 * multiplier,
          shadowColor: colors.black,
          shadowOffset: { height: 2 * multiplier, width: 2 * multiplier},
        }
        : { minHeight: menuHeight + (ios && !landscape ? 90 * multiplier : 60 * multiplier), top: ios && !landscape ? 90 * multiplier : 60 * multiplier, position: 'absolute' }, //tslint:disable-line
      ]}>
        <RX.View
          onLayout={(e) => { !menuHeight && this.props.dispatch({ type: 'MENU_SIZE', height: e.height })}}//tslint:disable-line
          onPress={width < md ? catcherPress : () => {}} // tslint:disable-line
          style={[
            styles.mainMenu,
            { width, top: 0 },
            width >= md
            ? {
              backgroundColor: colors.white,
              flexDirection: 'row',
              marginLeft: 78 * multiplier,
              maxWidth: 1200,
              minHeight: ios && !landscape ? 90 * multiplier : 40 * multiplier
            }
            : { minHeight: height > menuHeight + (ios && !landscape ? 90 * multiplier : 60 * multiplier) ? height : menuHeight + (ios && !landscape ? 90 * multiplier : 60 * multiplier) } //tslint:disable-line
          ]}>
          {menuSections.map((section: any, idx: number) =>
            <MenuSection
              last={idx === menuSections.length - 1}
              key={section.title}
              { ...{ ...section, index: idx, catcherPress }}
            />
          )}
        </RX.View>
      </RX.View>
    );
  }
}

export default connect(mapStateToProps)(MenuContainer);



// WEBPACK FOOTER //
// ./src/components/menu/menu_container/index.tsx